<template>
  <div id="home" class="maincont">
    <div class="ef--inner">
      <div class="topics">
        <div class="topics-area">
          <h3 class="topics-caption">Topix</h3>
          <ul class="topix-caption-electric">
            <li><span class="topix-caption-electric-label">前年{{ LastMonth }}月</span></li>
            <li><input type="text" class="topix-caption-electric-text" v-model="ElectricLastMonthLastYear" disabled></li>
            <li><span class="topix-caption-electric-label">{{ LastMonth }}月</span></li>
            <li><input type="text" class="topix-caption-electric-text" v-model="ElectricLastMonth" disabled></li>
          </ul>
        </div>

        <div class="topics-info">
          <div class="topics-content">
            <div class="topics-item">
              <h4 class="topics-item-caption">でんき予報リスク</h4>
              <ul class="topics-item-list">
                <li class="topics-item-list-item">
                  <div class="label level3">厳しい</div>
                  <div class="data">{{ topix.electrical_risk_strict }}</div>
                </li>
              </ul>
            </div>
            <div class="topics-item">
              <h4 class="topics-item-caption">前月電力使用実績比較[kWh]（電力使用実績÷分析係数）※上位5拠点</h4>
              <ul class="top5-list">
                <li class="top5-list-item" v-for="(item, index) in topix.power_usage_record" v-bind:key="index">
                  <div class="name"><a href="javascript:void(0);" @click="onDetail(item.account)">{{ item.name }}</a></div>
                  <div class="label" v-bind:class="getForecastLevel(item.level)">{{ item.power }}</div>
                </li>
              </ul>
            </div>
          </div>

          <div class="topics-control" v-show="this.showPowerGraphdataControl">
            <table class="list-table">
              <thead>
                <tr>
                  <th style="width:20%;" rowspan="2">事業所</th>
                  <th style="width:20%;" rowspan="2">抑制電力量</th>
                  <th style="width:20%;"rowspan="2">電力使用量累計</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in this.power_usage_record" v-bind:key="index">
                  <td>{{ item.name }}</td>
                  <td width="20%" style="text-align:right;">{{ item.control_power }}</td>
                  <td width="20%" style="text-align:right;">{{ item.usage_power}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="ef--inner graph-container">
      <div class="graph-header">
        <h2 class="graph-header-caption">事業所比較</h2>
        <ul class="graph-header-button">
          <li class="graph-header-button-item"><a href="javascript:void(0);" class="bt" @click="showModal = true">事業所選択</a><p>※最大5拠点</p></li>
          <li class="graph-header-button-item"><a href="javascript:void(0);" class="bt" @click="getGraphData">更新</a></li>
          <li class="graph-header-button-item"><a href="javascript:void(0);" class="bt" @click="onDownload">CSVダウンロード</a></li>
        </ul>
      </div>
      <div class="graph-content">
        <ul class="graph-control">
          <li class="graph-control-item">
            <span class="select-box">
              <select id="hyouji-graph" name="hyouji-graph" v-model="GraphType">
                <option value="1" selected="selected">電力使用実績（累計）</option>
                <option value="2">電力使用実績（分析）</option>
                <option value="3">検針データ</option>
              </select>
            </span>
          </li>
          <li class="graph-control-item">
            <span class="select-box">
              <select id="hyouji-kikan" name="hyouji-kikan" v-model="DispType">
                <option
                  v-for="(option, index) in DispTypeList"
                  v-bind:value="option.value"
                  v-bind:key="index"
                >{{ option.disp }}</option>
              </select>
            </span>
          </li>
          <li class="graph-control-item">
            <span class="select-box">
              <select id="hyouji-nengetsu" name="hyouji-nengetsu" v-model="DispDate">
                <option
                  v-for="(option, index) in DispDateList"
                  v-bind:value="option.value"
                  v-bind:key="index"
                >{{ option.disp }}</option>
              </select>
            </span>
          </li>
        </ul>
        <p class="label_left" style="position:relative;top:35px;">{{ dispScale }}</p>
        <div class="graph">
          <div id="shopComparison_legend" style="height: 22px;text-align: center;" ></div>
          <canvas id="canvas" height="80%"></canvas>
        </div>
      </div>
    </div>
    <select-store
      @close="showModal=false"
      v-if="showModal"
      :account="this.$store.state.parentID"
    ></select-store>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Chart from "chart.js";
import SelectStore from "../../components/SelectStore";
import Store from "../../store";
import Utils from "../../utils/utils";

export default {
  name: "shop_comparison",
  components: {
    SelectStore
  },
  data: function() {
    return {
      showModal: false,
      GraphType: 1,
      DispType: 1,
      DispDate: 0,
      DispTypeList: [],
      DispDateList: [],
      selectedStore: [],
      topix: [],
      graphData: [],
      showPowerGraphdataControl:true,
      power_usage_record: [],
      chart: null,
      LastMonth: 0,
      ElectricLastMonth: 0,
      ElectricLastMonthLastYear: 0,
      dispScale: ""
    };
  },
  watch: {
    GraphType: function(newValue, oldValue) {
      console.log("GraphType");
      console.log(newValue);
      this.setDispTypeList();
      this.setDateTypeList();
    },
    DispType: function(newValue, oldValue) {
      console.log("DispType");
      console.log(newValue);
      this.setDateTypeList();
    }
  },
  created: function() {
    console.log("created");
    this.setDispTypeList();
    this.setDateTypeList();
    this.$axios
      .get(`/srv/api/topix/${Store.state.parentID}`, {
        withCredentials: true
      })
      .then(response => {
        console.log("topix success");
        console.log(response.data);
        if (typeof response.data == "object") {
          this.topix = response.data;
          // 成功時は、グラフデータを取得
          let storeList = [];
          for (let i = 0; i < this.topix.power_usage_record.length; i++) {
            let storeInfo = {
              name: this.topix.power_usage_record[i].name,
              account: this.topix.power_usage_record[i].account
            };
            storeList.push(storeInfo);
          }
          console.log(storeList);
          this.selectedStore = storeList;
          this.LastMonth = this.topix.last_month;
          this.ElectricLastMonth = Utils.addComma(this.topix.electrical_sum_last_month) + "MWh";
          this.ElectricLastMonthLastYear = Utils.addComma(this.topix.electrical_sum_last_month_last_year) + "MWh";

          this.getGraphData();
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log("topix error");
        console.log(error);
      });
  },
  methods: {
    getDateTypeStr: function(value) {
      console.log("getDateTypeStr");
      if (this.GraphType == 1 || this.GraphType == 3) {
        return value + "年";
      } else if (this.GraphType == 2) {
        return value.substr(0, 4) + "年" + value.substr(4, 2) + "月";
      }
      return value;
    },
    setDispTypeList: function() {
      console.log("setDispTypeList");
      const dispYearMonth = [
        {
          value: 1,
          disp: "年間データ"
        },
        {
          value: 2,
          disp: "月間データ"
        }
      ];

      const dispYear = [
        {
          value: 1,
          disp: "年間データ"
        }
      ];

      if (this.GraphType == 1 || this.GraphType == 2) {
        this.DispTypeList = dispYearMonth;
      } else if (this.GraphType == 3) {
        this.DispTypeList = dispYear;
      }
      this.DispType = 1;
    },
    setDateTypeList: function() {
      console.log("setDateTypeList");
      const today = new Date();
      this.DispDateList = [];
      const year = today.getFullYear();
      const month = today.getMonth();
      let selectedValue = 0;

      if (this.DispType == 1) {
        // 今年と過去4年を表示
        for (let i = 0; i < 5; i++) {
          let dateInfo = {
            value: year - i,
            disp: year - i + "年"
          };
          this.DispDateList.push(dateInfo);
          if (i == 0) {
            selectedValue = dateInfo.value;
          }
        }
      } else if (this.DispType == 2) {
        // 今月と過去5か月を表示
        for (let i = 0; i < 6; i++) {
          const targetDate = new Date(year, month - i, 1);
          console.log(targetDate);
          const targetYear = targetDate.getFullYear();
          const targetMonth = targetDate.getMonth() + 1;
          let dateInfo = {
            value: targetYear * 100 + targetMonth,
            disp: targetYear + "年" + targetMonth + "月"
          };
          this.DispDateList.push(dateInfo);
          if (i == 0) {
            selectedValue = dateInfo.value;
          }
        }
      }
      console.log(this.DispDateList);
      this.DispDate = selectedValue;
    },
    getGraphData: function() {
      console.log("getGraphData");
      console.log(this.topix);
      console.log(this.GraphType);
      console.log(this.DispDate);
      console.log(this.DispType);
      console.log(this.selectedStore);
      if(this.GraphType == 1) {
        this.showPowerGraphdataControl = true;
      } else{
        this.showPowerGraphdataControl = false;
      }
      
      const param = {
        graph_type: this.DispType,
        date: this.DispDate,
        data_type: this.GraphType,
        store_list: this.selectedStore
      };

      this.$axios
        .post(`/srv/api/electric_power_graphdata_total/${Store.state.parentID}`, param, {
          withCredentials: true
        })
        .then(response => {
          console.log("electric_power_graphdata_total success");
          console.log(response.data);
          
          if (typeof response.data == "object") {
            this.graphData = response.data;
            let storeList = [];            
            for (let i = 0; i < response.data.store_list.length; i++) {
              let control_power = "-"
              let usage_power = "-"
              
              if(response.data.store_list[i].air_conditioner_control_flg == true && response.data.store_list[i].air_conditioner_signin_flg == true) {
                control_power  = response.data.store_list[i].control_power != null ? response.data.store_list[i].control_power : 0;                
              }

              usage_power = response.data.store_list[i].usage_power != null ? response.data.store_list[i].usage_power : 0;

              let storeInfo = {
                name: response.data.store_list[i].name,
                control_power: control_power == '-'? control_power : control_power + " MWh",
                usage_power: usage_power + " MWh",
              };              
              storeList.push(storeInfo);
            }
            this.power_usage_record = storeList;

            // 取得できたらグラフ表示を行う
            this.drawGraph(this.graphData);
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
            if (this.chart) {
              this.chart.destroy();
            }
          }
        })
        .catch(error => {
          console.log("electric_power_graphdata_total error");
          console.log(error);
          if (this.chart) {
            this.chart.destroy();
          }
        });
    },
    drawGraph: function(data) {
      console.log("drawGraph");
      console.log(data.store_list);
      console.log(data.store_list.length);

      if (data.store_list.length == 0) {
        console.log("no graph data");
        if (this.chart) {
          this.chart.destroy();
        }
        return;
      }

      if (this.GraphType == 1 || this.GraphType == 3) {
        this.dispScale = "(MWh)";
      } else {
        this.dispScale = "(kWh)";
      }

      const backgroundColorList = [
        'rgba(86, 161, 229, 1)',
        'rgba(255, 180, 180, 1)',
        'rgba(109, 190, 191, 1)',  
        'rgba(242, 163, 84, 1)',
        'rgba(145, 107, 246, 1)',
        'rgba(255, 0, 0, 1)'
      ];

      let labelData = [];
      console.log(data.store_list[0].data_list.length);
      for (let i = 0; i < data.store_list[0].data_list.length; i++) {
        labelData.push(data.store_list[0].data_list[i].date);
      }
      console.log(labelData);

      let graphDataList = [];
      let graphDataControlList = [];
      let totalGraphDataList = [];
      for (let i = 0; i < data.store_list.length; i++) {
        let valueList = [];
        for (let j = 0; j < data.store_list[i].data_list.length; j++) {
          if (data.store_list[i].data_list[j].value != null) {
            valueList.push(data.store_list[i].data_list[j].value);
          }
        }
        console.log(data.store_list[i].name);
        console.log(valueList);
        let graphData = {
          label: data.store_list[i].name,
          stack: i,
          data: valueList,
          backgroundColor: backgroundColorList[i]
        };
        graphDataList.push(graphData);
        
        if(data.store_list[i].air_conditioner_control_flg == true && data.store_list[i].air_conditioner_signin_flg == true){
          let valueControlList = [];
          if(data.store_list[i].control_list != null){
            for (let j = 0; j < data.store_list[i].control_list.length; j++) {
              if (data.store_list[i].control_list[j].value != null) {
                valueControlList.push(data.store_list[i].control_list[j].value);
              }
            }
            let graphControlData = {
              label: "削減量",
              stack: i,
              data: valueControlList,
              backgroundColor: backgroundColorList[5]
            };
            graphDataControlList.push(graphControlData);
          }        
        }                
      }

      if (this.GraphType == 1 && graphDataControlList.length > 0) {
        graphDataList.push.apply(graphDataList, graphDataControlList);
      } 
      
      var chartData = {
        labels: labelData,
        datasets: graphDataList
      };

      console.log("chartData");
      console.log(chartData);


      
  
      var options = {
        legend: false,
        legendCallback: function(g) {
          var h = [];
          h.push('<ul style="display: inline-flex;">');
          for (var f = 0; f < g.data.datasets.length; f++) {
            if (g.data.datasets[f].label != "削減量") {
              h.push("<li style='padding: 0 10px;'>");
              h.push("<span style='background-color:");
              h.push(backgroundColorList[f]);
              h.push(";display: inline-block;width:45px;height:11px;'></span><div style='display: inline-block;padding-left: 5px;'>");
              h.push(g.data.datasets[f].label);
              h.push("</div></li>");
            }
            
          }
          h.push("</ul>");
          return h.join("");
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              callback: function(label, index, labels) {
                return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              }
            }
          }]
        }
      };
      
      if (this.chart) {
        this.chart.destroy();
      }
      
      this.chart = new Chart(
        document.getElementById("canvas").getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: options,          
        }
      );  
      $("#shopComparison_legend").html(this.chart.generateLegend()); 
    },    
    onDetail: function(account) {
      console.log(account);
      this.$store.dispatch("setConfirm", { isConfirmed: true });
      this.$store.dispatch("setChildID", account);
      let route = this.$router.resolve({path: '/'});
      window.open(route.href, '_blank');
    },
    onDownload: function() {
      console.log("onDownload");
      console.log(this.GraphType);
      console.log(this.DispDate);
      console.log(this.DispType);

      const param = {
        graph_type: this.DispType,
        date: this.DispDate,
        data_type: this.GraphType
      };

      this.$axios
        .post(`/srv/api/store_comparison_data/${Store.state.parentID}`, param, {
          withCredentials: true,
          responseType: "blob",
          exposedHeaders: ["Content-Disposition"]
        })
        .then(response => {
          console.log(response);
          console.log(response.headers["content-disposition"]);
          let fileName = "";
          const contentDisposition = response.headers["content-disposition"];
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, "");
          }
          console.log(fileName);

          if (
            response.headers["content-type"].indexOf("application/json") != -1
          ) {
            alert("ダウンロードできませんでした");
            return;
          }
          const dl = document.getElementById("downloadLink");
          if (dl != undefined) dl.parentNode.removeChild(dl);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("id", "downloadLink");
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.$emit("close");
        })
        .catch(error => {
          // ...
          console.log(error);
        });
    }
  }
};
</script>
